import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useNavigate } from "react-router";
import ModalAssociateScreen from '../Flows/ModalAssociateScreen'
import { Methods } from '../../api/Request'
import ModalLinkingScreen from '../Flows/ModalLinkingScreen'
import { associateScreenFlow } from '../../api/flow'
import { connect } from "react-redux";
import { routes } from "../../config/routes";

const FlowsContainer = ({ currentCompany }) => {
  const [modalAssociateScreen, setModalAssociateScreen] = useState(null)
  const [modalLinkingScreen, setModalLinkingScreen] = useState(null)
  const [loadingAssociate, setLoadingAssociate] = useState(null)
  const navigate = useNavigate()

  const associateScreen = (screen, method) => {
    if (!screen.uuid && method === 'POST') {
      setModalLinkingScreen(screen)
      setModalAssociateScreen({ ...modalAssociateScreen, display: false })
    } else {
      setLoadingAssociate(screen.id)
      associateScreenFlow(screen, modalAssociateScreen.rootFlow, method)
        .then((res) => {
          setModalAssociateScreen({ ...modalAssociateScreen, rootFlow: res })
        })
        .catch()
        .finally(() => setLoadingAssociate(false))
    }
  }
  if (!currentCompany)
    return <Navigate to='/companies' replace={true} />
  return (
    <div>
      {modalAssociateScreen?.display && (
        <ModalAssociateScreen
          companyId={currentCompany.id}
          currentFlow={modalAssociateScreen.currentFlow}
          rootFlow={modalAssociateScreen.rootFlow}
          loadingAssociate={loadingAssociate}
          onConfirm={(screen) => {
            associateScreen(screen, Methods.POST)
          }}
          onRemove={(screen) => associateScreen(screen, Methods.DELETE)}
          closeModal={() => setModalAssociateScreen(false)}
        />
      )}
      {modalLinkingScreen && (
        <ModalLinkingScreen
          onConfirm={(screen, callBack) =>
            associateScreen(screen, Methods.POST, callBack)
          }
          closeModal={() => setModalLinkingScreen(false)}
          data={modalLinkingScreen}
          rootFlow={modalAssociateScreen.rootFlow}
          subscribeTopics={{ screen_token: [modalLinkingScreen.token] }}
        />
      )}
      <Outlet context={[modalAssociateScreen, setModalAssociateScreen]} />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentCompany: state.auth?.currentCompany,
  }
}
export default connect(mapStateToProps, null)(FlowsContainer)
